export const SEGMENT_TYPES = {
  WEB_VISITOR: 'WEB_VISITOR',
  OBJECT_LIST: 'OBJECT_LIST'
};
export const SUPPORTED_SEGMENT_TYPES = [SEGMENT_TYPES.OBJECT_LIST, SEGMENT_TYPES.WEB_VISITOR];